export type FulfillmentLeg = "outbound" | "return";
export type FulfillmentOwner = "festi" | "customer";

const CUSTOMER_HOURS: Record<FulfillmentLeg, string> = {
  outbound: "09h - 16h",
  return: "09h - 13h",
};

export const getFulfillmentHours = (leg: FulfillmentLeg, owner: FulfillmentOwner) =>
  owner === "festi" ? "09h - 17h" : CUSTOMER_HOURS[leg];
